import changeTheNumber from "./count";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    changeTheNumber
})

export default rootReducer;